<div
  class="header h-[55px] flex justify-start items-center mb-[18px] bg-[#F1F3F5]"
>
  <p class="!m-0 pl-[50px]">
    {{ projectName }} - Pre-Qualification Questionnaire (PQQ)
  </p>
  <p
    class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
  >
    Select Work Packages
  </p>
</div>

<div class="mt-[7px] ml-[30px] pl-[20px]">
  <div class="!pl-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[429px]" appearance="outline">
          <mat-label>Enter PQQ Title</mat-label>
          <input
            matInput
            type="text"
            [formControl]="pqqTitle"
            placeholder="Enter PQQ Title"
          />
          <mat-error
            class="text-[14px]"
            *ngIf="
              pqqTitle.hasError('required') &&
              (pqqTitle.touched || pqqTitle.dirty)
            "
          >
            PQQ Title is required.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="!mt-5 w-[100%] flex justify-between items-center">
    <div
      *ngIf="pqqData?.projectWPDetails[0]"
      class="flex justify-start !h-[50px]"
    >
      <label class="cursor-pointer flex" (change)="selectAllWorkPackages()">
        <input
          type="checkbox"
          class="h-[20px] w-[20px] mr-[12px]"
          [checked]="selectAllChecked"
        />
        <p class="packages-name text-[#3B71CA]">
          {{ selectAllChecked ? "Deselect All" : "Select All" }}
        </p>
      </label>
    </div>
  </div>
  <div
    *ngFor="let workpackage of pqqData?.projectWPDetails || []; let i = index"
    class="w-[100%] flex justify-between items-center"
  >
    <div class="flex justify-start !h-[50px]">
      <input
        type="checkbox"
        class="h-[20px] w-[20px] mr-[12px]"
        [checked]="isSelected(workpackage?.id)"
        (change)="toggleWorkPackageSelection($event, workpackage)"
      />
      <p class="packages-name">{{ workpackage?.work_package?.name }}</p>
    </div>
  </div>

  <div class="!pl-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%] !h-[130px]" appearance="outline">
          <mat-label> Additional Information </mat-label>
          <input
            matInput
            type="text"
            [formControl]="w_p_description"
            placeholder="Additional Information"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="handleBack()" type="button" class="back-btn">Back</button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>
